import { useId, type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const InstagramSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => {
  const pathId = useId();

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <defs>
          <clipPath id={pathId}>
            <path fill="none" d="M4 3.99h20.23v20.23H4z" />
          </clipPath>
        </defs>
        <g clip-path={`url(#${pathId})`}>
          <path
            d="M22.17 18.39c0 2.07-1.69 3.76-3.76 3.76H9.83c-2.07 0-3.76-1.69-3.76-3.76V9.81c0-2.07 1.69-3.76 3.76-3.76h8.58c2.07 0 3.76 1.69 3.76 3.76v8.58Zm-3.76-14.4H9.83C6.62 3.99 4 6.61 4 9.82v8.58c0 3.21 2.61 5.83 5.83 5.83h8.58c3.21 0 5.83-2.61 5.83-5.83V9.82c0-3.21-2.61-5.83-5.83-5.83"
            fill="currentColor"
          />
          <path
            d="M14.12 16.64c-1.4 0-2.54-1.14-2.54-2.54s1.14-2.54 2.54-2.54 2.54 1.14 2.54 2.54-1.14 2.54-2.54 2.54m0-7.23c-2.59 0-4.7 2.11-4.7 4.7s2.11 4.7 4.7 4.7 4.7-2.11 4.7-4.7-2.11-4.7-4.7-4.7M19.38 7.37c-.77 0-1.39.62-1.39 1.39s.62 1.39 1.39 1.39 1.39-.62 1.39-1.39-.62-1.39-1.39-1.39"
            fill="currentColor"
          />
        </g>
      </svg>
    </Icon>
  );
};

export default InstagramSVG;
